import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import Vue from 'vue';

import { sleep } from '../utils';
export var Ws = function () {
  //当前连接状态
  function Ws() {
    _classCallCheck(this, Ws);

    this.BaseUrl = "wss://call.9ikk.cn/ws";
    this.LoginStatus = false;
    this.ConnectStatus = false;
    this.Instance = null;

    this.check_load();
    this.load();
  }

  /**
   * 连接实例
   * @type { WebSocket }
   */


  //当前登录状态


  _createClass(Ws, [{
    key: 'getInstance',
    value: function getInstance() {
      return this.Instance;
    }

    /**
     * 重新连接
     */

  }, {
    key: 'load',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.ConnectStatus) {
                  _context.next = 7;
                  break;
                }

                console.log("正在连接");
                try {
                  this.Instance = new WebSocket(this.BaseUrl);
                  this.init_listener();
                } catch (error) {
                  console.log(error);
                }
                _context.next = 5;
                return sleep(3000);

              case 5:
                _context.next = 0;
                break;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _ref.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: 'check_load',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var userInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.LoginStatus) {
                  _context2.next = 7;
                  break;
                }

                /**
                * 轮询检查用户是否登录
                * 登录了发起信息
                */
                console.log("检查用户登录信息");
                try {
                  userInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

                  if (userInfo && userInfo.id > 0) {
                    //
                    this.getInstance().send(_JSON$stringify({ actionType: "login", userId: userInfo.id }));
                    this.LoginStatus = true;
                    console.log("检查成功");
                  } else {
                    console.log("没登陆");
                  }
                } catch (error) {
                  // 用户没登陆
                }
                _context2.next = 5;
                return sleep(1000);

              case 5:
                _context2.next = 0;
                break;

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function check_load() {
        return _ref2.apply(this, arguments);
      }

      return check_load;
    }()
  }, {
    key: 'init_listener',
    value: function init_listener() {
      var _this = this;

      //监听连接打开事件
      this.Instance.addEventListener('open', function (event) {
        //监听关闭事件
        _this.Instance.addEventListener('close', function (event) {
          // 尝试重连
          _this.ConnectStatus = false;
          _this.LoginStatus = false;
          _this.load();
        });

        //监听错误事件
        _this.Instance.addEventListener('error', function (error) {
          _this.ConnectStatus = false;
          _this.LoginStatus = false;
        });

        //监听接收到消息事件
        _this.Instance.addEventListener('message', function (event) {
          try {
            var data = JSON.parse(event.data);
            console.log("收到socket 消息", data);
          } catch (error) {
            console.log("收到socket 消息", event.data);
          }
          // 处理从服务器接收到的数据，比如存入Vuex store
        });
        _this.ConnectStatus = true;
        Vue.prototype.$socket = _this.getInstance();
        console.log("连接成功");
      });
    }
  }]);

  return Ws;
}();